// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "sale_item".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { saleItemTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "sale_item" table (1:1 with a DB row, on the wire). */
export const saleItemAtomSchema = z.object({
    id: z.string(),
    saleId: z.string(),
    itemType: z.enum(saleItemTypeValues),
    appointmentId: z.string().nullable(),
    serviceId: z.string().nullable(),
    productId: z.string().nullable(),
    membershipPlanId: z.string().nullable(),
    giftCardId: z.string().nullable(),
    practitionerId: z.string().nullable(),
    name: z.string(),
    quantity: z.number(),
    unitPriceCents: z.number(),
    totalCents: z.number(),
    giftCardFaceValueCents: z.number().nullable(),
    giftCardExpiry: z.string().nullable(),
    clientPackageId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=saleItem.js.map